import { useEffect, useRef, useState } from 'react';

// eslint-disable-next-line import/no-named-as-default
import { useLingui } from '@lingui/react/macro';
import { OktaSignIn } from '@okta/okta-signin-widget';
import '@okta/okta-signin-widget/css/okta-sign-in.min.css';
import PropTypes from 'prop-types';
import './okta-custom.css';

const OktaSignInWidget = ({ config, onSuccess, onError }: any) => {
  const widgetRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useLingui();

  useEffect((): any => {
    if (!widgetRef.current) {
      return false;
    }

    const widget = new OktaSignIn(config);

    widget.on('afterRender', (context: any) => {
      const helpLink = document.getElementsByClassName('js-help')[0];
      if (context.controller === 'primary-auth') {
        helpLink.textContent = t`Reset Password`;
        helpLink.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          (widget.router.appState as any).trigger(
            'navigate',
            'signin/forgot-password',
          );
        });
      } else if (helpLink) {
        (helpLink as HTMLElement).style.visibility = 'hidden';
      }
    });

    // after successful authentication with IdP
    if (config.features?.idpDiscovery) {
      widget.authClient.session.exists().then((sessionExists) => {
        if (sessionExists) {
          setIsLoading(true);
          widget.authClient.token
            .getWithoutPrompt()
            .then((response) => {
              widget.authClient.tokenManager.setTokens(response.tokens);
              onSuccess(response.tokens);
            })
            .catch(onError);
        }
      });
    }

    widget
      .showSignInToGetTokens({
        el: widgetRef.current,
      })
      .then((tokens) => {
        if (tokens) {
          // Extract IdP info (if available in claims)
          const idToken = tokens.idToken;
          const idp = idToken?.claims?.idp || idToken?.claims?.idp_id;

          if (idp) {
            localStorage.setItem('idp', String(idp));
          }
          onSuccess(tokens);
        }
      })
      .catch(onError);

    return () => widget.remove();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div>{isLoading ? t`Loading...` : ''}</div>
      {/* @ts-expect-error TS(2322): Type 'MutableRefObject<undefined>' is not assignab... Remove this comment to see the full error message */}
      <div hidden={isLoading} style={{ marginTop: '20vh' }} ref={widgetRef} />
    </div>
  );
};

OktaSignInWidget.propTypes = {
  config: PropTypes.any,
  onSuccess: PropTypes.any,
  onError: PropTypes.any,
};

export default OktaSignInWidget;
